import React from 'react';
import PropTypes from 'prop-types';
import { observable } from 'mobx';
import { observer } from 'mobx-react';
import DatePicker from 'react-datepicker';
import parse from 'date-fns/parse';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes } from '@fortawesome/free-solid-svg-icons';

import { dateFormat } from './AppointmentDates';

class CustomInput extends React.Component {
	
	render() {
		const { value, onClick } = this.props;
		
		return <div className="date-pick" onClick={onClick}>
			{value}
		</div>
	}
}

@observer
export default class DateEdit extends React.Component {

	render() {
		const { value, onChange, onDelete } = this.props;
		
		return <div className="date">
			<DatePicker
				selected={value}
				dateFormat={dateFormat}
				onChange={onChange}
				customInput={<CustomInput />}
			/>
			<FontAwesomeIcon className="delete-btn" icon={faTimes} onClick={onDelete}/>
		</div>;
	}
	
}
